import React, { useEffect, useState } from "react";
import "./header.css";

const Header = () => {
  /* =============== Toggle Menu =============== */
  const [toggle, setToggle] = useState(false);
  const [activeNav, setActiveNav] = useState("#home");

  /* =============== Change Header Background on Scroll =============== */
  useEffect(() => {
    const onScroll = () => {
      const header = document.querySelector(".header");
      if (!header) return;

      if (window.scrollY >= 80) {
        header.classList.add("scroll-header");
      } else {
        header.classList.remove("scroll-header");
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll(); // run once on mount

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="header">
      <nav className="nav container">
        <a href="#home" className="nav__logo">
          Vamsi
        </a>

        <div className={toggle ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid">
            <li className="nav__item">
              <a
                href="#home"
                onClick={() => setActiveNav("#home")}
                className={
                  activeNav === "#home"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-estate nav__icon" /> Home
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#about"
                onClick={() => setActiveNav("#about")}
                className={
                  activeNav === "#about"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-user nav__icon" /> About
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#skills"
                onClick={() => setActiveNav("#skills")}
                className={
                  activeNav === "#skills"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-file-alt nav__icon" /> Skills
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#services"
                onClick={() => setActiveNav("#services")}
                className={
                  activeNav === "#services"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-briefcase-alt nav__icon" /> Services
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#portfolio"
                onClick={() => setActiveNav("#portfolio")}
                className={
                  activeNav === "#portfolio"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-scenery nav__icon" /> Portfolio
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#certifications"
                onClick={() => setActiveNav("#certifications")}
                className={
                  activeNav === "#certifications"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-award nav__icon" /> Certifications
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#contact"
                onClick={() => setActiveNav("#contact")}
                className={
                  activeNav === "#contact"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-message nav__icon" /> Contact
              </a>
            </li>
          </ul>

          {/* Close menu */}
          <i
            className="uil uil-times nav__close"
            onClick={() => setToggle(false)}
          />
        </div>

        {/* Open menu */}
        <div className="nav__toggle" onClick={() => setToggle(true)}>
          <i className="uil uil-apps" />
        </div>
      </nav>
    </header>
  );
};

export default Header;
